import { render, staticRenderFns } from "./list.view.vue?vue&type=template&id=2cc609fe&"
import script from "./list.view.ts?vue&type=script&lang=js&"
export * from "./list.view.ts?vue&type=script&lang=js&"
import style0 from "./list.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports